import { Component, HostListener, OnDestroy, OnInit, signal } from '@angular/core';

import { Router } from '@angular/router';

import { FileNotificationService } from '../../../../../modules/visualizacao-de-arquivos/services/file-notification.service';
import { FileNotification } from '../../../../../modules/visualizacao-de-arquivos/models/responses/file-notification.model';

@Component({
  selector: 'app-notification-bell',
  standalone: true,
  imports: [],
  templateUrl: './notification-bell.component.html',
  styleUrl: './notification-bell.component.scss'
})
export class NotificationBellComponent implements OnInit, OnDestroy {
  public isOpen = signal(false);

  private pollingInterval: ReturnType<typeof setInterval> | null = null;

  public readonly notifications = this.fileNotificationService.notifications;
  public readonly unreadLabel = this.fileNotificationService.unreadLabel;
  public readonly loading = this.fileNotificationService.loading;

  constructor(
    public fileNotificationService: FileNotificationService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.fileNotificationService.fetchNotifications();
    this.pollingInterval = setInterval(() => {
      if (!this.isOpen()) {
        this.fileNotificationService.fetchNotifications();
      }
    }, 60000);
  }

  ngOnDestroy(): void {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  }

  public togglePanel(): void {
    const opening = !this.isOpen();
    this.isOpen.set(opening);
    if (opening) {
      this.fileNotificationService.fetchNotifications();
    }
  }

  public onNotificationClick(notification: FileNotification): void {
    if (!notification.viewed) {
      this.fileNotificationService.markAsViewed(notification.id);
    }
    const folder = this.fileNotificationService.folderPath(notification);
    this.isOpen.set(false);
    this.router.navigate(['/file-manager'], { queryParams: { folder } });
  }

  public formatDate(isoDate: string): string {
    return this.fileNotificationService.formatDate(isoDate);
  }

  public markAllAsViewed(): void {
    this.fileNotificationService.markAllAsViewed();
  }

  public fileIcon(n: FileNotification): string {
    const ext = n.fileName?.split('.').pop()?.toLowerCase() ?? '';
    const type = n.fileType ?? '';
    if (type.startsWith('image/') || ['png', 'jpg', 'jpeg', 'gif', 'webp'].includes(ext)) return 'image';
    if (type === 'video/mp4' || ext === 'mp4') return 'video';
    if (type === 'application/pdf' || ext === 'pdf') return 'pdf';
    if (type.includes('zip') || ext === 'zip') return 'zip';
    return 'other';
  }

  public onThumbnailError(event: Event): void {
    const img = event.target as HTMLImageElement;
    img.style.display = 'none';
  }

  @HostListener('document:click', ['$event'])
  onOutsideClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.notification-bell-wrapper')) {
      this.isOpen.set(false);
    }
  }
}
